import { useAuth } from '@clerk/react';
import { CLERK_CONFIGURED } from './clerkConfig';

// useAuth() throws when no ClerkProvider is mounted, and index.js only mounts
// one when a publishable key exists. The main site's pages (the assistant among
// them) therefore cannot call useAuth() directly -- they render in both states.
//
// CLERK_CONFIGURED is a build-time constant, so which of these two is exported
// is decided once at module load and never changes for the life of the app.
// That keeps the hook call unconditional inside whichever one is chosen, which
// is what the rules of hooks actually require.
const useClerkAuth = () => useAuth();
const useNoAuth = () => ({ isLoaded: true, isSignedIn: false, getToken: async () => null });

export const useOptionalAuth = CLERK_CONFIGURED ? useClerkAuth : useNoAuth;
